import { http } from '@/core/api/';
import qs from 'querystring';

const axiosConfig = (properties) => ({
  params: {
    ...properties,
  },
  paramsSerializer: (params) => qs.stringify(params),
});

export default {
  /**
   *
   * @param {*} properties = {
   * AcademicYearId,
   * CenterId,
   * RegionId,
   * DistrictId,
   * MunicipalityId,
   * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
   * }
   */
  async getRegions(properties) {
    try {
      const { data } = await http.get(
        'api/location/regions',
        axiosConfig(properties)
      );
      if (data) return data;
    } catch {
      return [];
    }
  },
  /**
   *
   * @param {*} properties = {
   * AcademicYearId,
   * CenterId,
   * RegionId,
   * DistrictId,
   * MunicipalityId,
   * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
   * }
   */
  async getDistricts(properties) {
    try {
      const { data } = await http.get(
        'api/location/districts',
        axiosConfig(properties)
      );
      if (data) return data;
    } catch {
      return [];
    }
  },
  /**
   *
   * @param {*} properties = {
   * AcademicYearId,
   * CenterId,
   * RegionId,
   * DistrictId,
   * MunicipalityId,
   * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
   * }
   */
  async getMunicipalities(properties) {
    try {
      const { data } = await http.get(
        'api/location/municipalities',
        axiosConfig(properties)
      );
      if (data) return data;
    } catch {
      return [];
    }
  },
  /**
   *
   * @param {*} properties = {
   * AcademicYearId,
   * CenterId,
   * RegionId,
   * DistrictId,
   * MunicipalityId,
   * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
   * }
   */
  async getSchools(properties) {
    try {
      const { data } = await http.get(
        'api/location/schools',
        axiosConfig(properties)
      );
      if (data) return data;
    } catch {
      return [];
    }
  },
  /**
   *
   * @param {*} properties = {
   * AcademicYearId,
   * CenterId,
   * RegionId,
   * DistrictId,
   * MunicipalityId,
   * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
   * }
   */
  async getCenters(properties) {
    try {
      const { data } = await http.get(
        'api/location/centers',
        axiosConfig(properties)
      );
      if (data) return data;
    } catch {
      return [];
    }
  },
  async getOres() {
    try {
      const { data } = await http.get('api/location/ores');
      if (data) return data;
    } catch {
      return [];
    }
  },
};
